// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"ec13c770","884":"4ebd23f3","977":"caea2f6b"}[chunkId] + ".chunk.js";
};